module.exports = __webpack_public_path__ + "static/graphiql-9685bbacb4fa5456f56cc186b9355f00.gif";